import client from "utils/api";
import store from 'utils/store'
import momentTZ from 'moment-timezone'
function getCurrentUser(){
  return client().get(`/users/me`)
    .then((response) => {
      if(response.data.timezone){
        store.dispatch({type:"UPDATE_USER", payload: response.data})
      }else{
        client().post("/users/me/edit", {timezone: momentTZ.tz.guess()}).then(_response=>{
          store.dispatch({type:"UPDATE_USER", payload: _response.data})
        })
      }
    }).catch(err=>{store.dispatch({type:"LOGOUT"})})
}

export default {
  getCurrentUser
}



// WEBPACK FOOTER //
// ./src/api.js